<script setup lang="ts">

</script>

<template>
  <div lt-md="text-14px lh-18px" md="text-16px lh-24px text-center">
    <div class="grid" lt-md="grid-cols-2 gap-[0_6px]" md="grid-cols-[auto_1fr_1fr] gap-[0_12px]">
      <div class="relative flex-center rd-t-8px py-16px font-700" lt-md="hidden" md="px-24px" bg="purple-5 op-15" c="#161636 op-50">
        {{ $t('game.conf_title') }}
      </div>
      <div class="relative flex-center rd-t-8px py-16px font-700" lt-md="px-12px" md="px-24px" bg="purple-5" c="#fff">
        <Icon class="absolute h-full w-auto" inset="is-0 bs-0" name="GameRecommendThumb" />
        {{ $t('game.recommend_conf_title') }}
      </div>
      <div class="relative flex-center rd-t-8px py-16px font-700" lt-md="px-12px" md="px-24px" bg="purple-5 op-15" c="#161636 op-90">
        {{ $t('game.min_conf_title') }}
      </div>
      <template v-for="i in 5" :key="i">
        <div class="relative py-16px font-700" lt-md="hidden" md="px-24px flex-center" :class="i === 5 ? 'rd-b-8px' : 'b-b b-solid b-#000 b-op-5'" bg="#fff" c="#161636 op-50">
          {{ $t(`game.conf_text_${i}`) }}
        </div>
        <div class="relative py-16px font-700" lt-md="px-12px text-12px" md="px-24px flex-center" :class="i === 5 ? 'rd-b-8px' : 'b-b b-solid b-#000 b-op-5'" bg="#fff" c="purple-5">
          <p class="mb-4px c-#161636 c-op-50 font-400 md:hidden">
            {{ $t(`game.conf_text_${i}`) }}
          </p>
          {{ $t(`game.recommend_conf_text_${i}`) }}
        </div>
        <div class="relative py-16px font-700" lt-md="px-12px text-12px" md="px-24px flex-center" :class="i === 5 ? 'rd-b-8px' : 'b-b b-solid b-#000 b-op-5'" bg="#fff" c="#161636 op-90">
          <p class="mb-4px c-#161636 c-op-50 font-400 md:hidden">
            {{ $t(`game.conf_text_${i}`) }}
          </p>
          {{ $t(`game.min_conf_text_${i}`) }}
        </div>
      </template>
    </div>
  </div>
</template>

<style lang="scss" scoped>
</style>
